import './index.css';
function debounce(callback, waitMs) {
    let timeout = 0;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            callback(...args);
        }, waitMs);
    };
}

export { debounce };
//# sourceMappingURL=utils.js.map
